import { Component, OnInit } from '@angular/core';
import { BaseControlComponent } from '../base-control/base-control.component';
import { ContextInteractionService } from '../../services/context-interaction.service';


@Component({
    selector: 'app-address',
    templateUrl: './address.component.html',
    styleUrls: ['./address.component.scss'],
    standalone: false
})

export class AddressComponent extends BaseControlComponent implements OnInit {
    static componentName = 'AddressComponent';

    public selectedItem: any;
    public items: Array<any> = new Array<any>();
    public states: Array<any> = ['AL','AK', 'AZ', 'AR', 'CA', 'CO','CT', 'DE',
        'FL', 'GA','HI', 'ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI',
        'MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR',
        'PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'];

    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }
    

    ngOnInit() {

    }
}
